import { PolicyLookupResponse } from '@uw-verisk/business-ui';
import { Component, OnInit, Inject } from '@angular/core';
import { UiBlockService } from './core/ui-block.service';
import { Store } from '@ngrx/store';
import { VIEW_PERMISSIONS } from './store/actions/user-preferences-action';
import { AppState } from './store/app.state';
import { UserPreferenceResponse } from './store/model/user-preferences.interface';
import { VIEW_POLICY_INFO } from './store/actions/policy-lookup-action';
import { IAppConfig } from './models/config';
import { AppService } from './app.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Observable } from 'rxjs';
import { OktaUserInfoService } from 'src/app/core/okta-user-info.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  public isUiBlocked = false;
  displayNav: boolean;
  appConfig: IAppConfig;
  userApiUrl: string;
  lookupApiUrl: string;
  displayContent: boolean;
  userResponse: any;
  isDisclaimerLoaded: boolean;
  isSuperUser: boolean;
  isImpersonateMode: boolean;

  public isAuthenticated$!: Observable<boolean>;
  public name$: Observable<string>;

  constructor(
    private appService: AppService,
    private store: Store<AppState>,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    private oktaUserInfoService: OktaUserInfoService,
    private readonly uiBlockService: UiBlockService) {
    this.uiBlockService.block$.subscribe(blocked => {
      this.isUiBlocked = blocked;
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.oktaAuth.session.get().then(user => {
          if (user.status !== 'ACTIVE')
            this.oktaAuth.signOut();
        },
          error => {
            this.oktaAuth.signOut();
          });
      }
    });
  }

  async ngOnInit() {
    this.appConfig = this.appService.readConfig() || ({} as any);
    this.oktaUserInfoService.getUserInfo().subscribe((userInfo) => {
      if (userInfo && this.appConfig) {
        this.appConfig.username = userInfo.preferred_username;
        this.appConfig.userINumber = this.appConfig.username.split('@')[0];
      }
    });
  }

  userInfo(resp: UserPreferenceResponse) {
    this.displayNav = true;
    this.store.dispatch({
      type: VIEW_PERMISSIONS,
      payload: resp,
    });
  }

  policyInfo(resp: PolicyLookupResponse) {
    this.store.dispatch({
      type: VIEW_POLICY_INFO,
      payload: resp,
    });
  }
}
